import axios from 'axios';
import { takeLatest, call, put } from 'redux-saga/effects';
import * as types from './types';
import config from '../../config/app_config';
import { getClient } from '../../common/utils';

export function* getClientEntitiesWatcherSaga() {
  yield takeLatest(types.GET_CLIENT_ENTITIES_REQUEST, workerSaga);
}

export function fetchData() {
  const client = getClient();
  const url = `${config.API_ROOT_URL}/v1/client/${client}/entities/`;

  return axios.get(url)
    .then(val => val)
    .catch(err => err);
}

export function* workerSaga() {
  try {
    const response = yield call(fetchData);

    if (response && response.status === 200) {
      const { data } = response;
      yield put({ type: types.GET_CLIENT_ENTITIES_SUCCESS, data });
      // Check for zero entities
      if (data?.length > 0) {
        yield put({ type: types.GET_PERKS_CALL_REQUEST, entitySlug: data[0].slug });
      }
    } else {
      yield put({ type: types.GET_CLIENT_ENTITIES_FAILED, error: 'Failed'});
    }
  } catch (error) {
    console.log(error)
    yield put({ type: types.GET_CLIENT_ENTITIES_FAILED, error });
  }
}
